<template>

    <!-- 基本信息 -->
    <div class="content-payment-table">
      <div class="table-bd">
        <custom-table ref="table" :data="data" :loading="isLoading" :column="tableColumn" :slots="['productInfo']" :filterArr="['productCode']">
          <!-- productInfo -->
          <template slot="productInfo" slot-scope="scope">
            <p>{{ i18n.page_content_productCode }}：{{ scope.row.productCode }}</p>
            <p>{{ i18n.page_content_rentalTerm }}：{{ scope.row.rentalTerm }}</p>
            <p>{{ i18n.page_content_deviceBizType }} ：{{ scope.row.deviceBizType }}</p>
            <p>{{ i18n.page_content_paymentNode }}: {{ getDicValue('payment_node', scope.row.paymentNode) }}</p>
          </template>
        </custom-table>
      </div>

    </div>


</template>

<script>
import languageInjectMixins from '@/mixins/language_inject_mixins';

export default {
  mixins: [languageInjectMixins],

  props: {
    data: [Array]
  },
  data() {
    return {
      tableCode: 'contract_payment',
      isLoading: false,
    };
  },

  mounted() {
    this.getTableColumn();
  },

};
</script>

<style lang="scss">
@import "@/style/colors.scss";;
.content-payment-table {
  // padding: 14px 24px 0;
}
</style>
